import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Container, Typography, Paper, Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Button, CircularProgress, Alert } from '@mui/material';

axios.defaults.withCredentials = true;

function UserListPage() {
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const checkAdminAndFetchUsers = async () => {
      try {
        const statusResponse = await axios.get('/api/users/status');
        if (statusResponse.data.loggedIn && statusResponse.data.user.role === 'admin') {
          setUserRole('admin');
          const usersResponse = await axios.get('/api/users/list');
          setUsers(usersResponse.data);
        } else {
          setMessage('Access Denied: You must be an admin to view this page.');
        }
      } catch (error) {
        setMessage('Error: ' + (error.response?.data || error.message));
      } finally {
        setLoading(false);
      }
    };
    checkAdminAndFetchUsers();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/users/${id}`);
      setUsers(users.filter(user => user.id !== id));
    } catch (error) {
      setMessage('Error deleting user: ' + (error.response?.data || error.message));
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  if (userRole !== 'admin') {
    return (
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Alert severity="error">{message}</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          User List
        </Typography>
        {message && <Alert severity="error" sx={{ mb: 2 }}>{message}</Alert>}
        {users.length > 0 ? (
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Username</TableCell>
                  <TableCell>Role</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map((user) => (
                  <TableRow
                    key={user.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {user.username}
                    </TableCell>
                    <TableCell>{user.role}</TableCell>
                    <TableCell>
                      <Button variant="contained" component={Link} to={`/users/${user.id}/manage`}>
                        Manage
                      </Button>
                      {/* TODO: Remove this before production */}
                      <Button variant="contained" color="secondary" onClick={() => handleDelete(user.id)} sx={{ ml: 1 }}>
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography>No users found.</Typography>
        )}
      </Paper>
    </Container>
  );
}

export default UserListPage;